import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const Button = styled.button`
  font-family: ${props => props.theme.fontFamily};
  border: none;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 88px;
  height: 36px;
  border-radius: 8px;
  margin-left: 10px;
  font-size: ${props => props.theme.fontSizeSmall};
  font-weight: 600;
  transition: 0.2s;
  padding: 0px;
  
  &:focus {
    outline: none;
  }
`

export const ButtonPrimary = styled(Button)`
 background-color: ${props => props.theme.buttonColorPrimary};
 color: ${props => props.theme.buttonTextColorPrimary}; 
 
 &:hover {
  background-color: ${props => props.theme.buttonColorPrimaryHover};
 }
 
 &:active {
  background-color: ${props => props.theme.buttonColorPrimaryActive};
 }
 
 &:disabled {
  background-color: ${props => props.theme.buttonColorPrimaryDisabled};
 }
`

export const ButtonPrimaryWide = styled(ButtonPrimary)`
  width: 270px;
  height: 40px;
`

export const ButtonSecondary = styled(Button)`
 background-color: ${props => props.theme.buttonColorSecondary};
 color: ${props => props.theme.buttonTextColorSecondary}; 
 
 &:hover {
  background-color: ${props => props.theme.buttonColorSecondaryHover};
 }
 
 &:active {
  background-color: ${props => props.theme.buttonColorSecondaryActive};
 }
  
 &:disabled {
  background-color: ${props => props.theme.buttonColorSecondaryDisabled};
 }
`

export const ButtonSecondaryLink = (props) => {
  const StyledLink = styled(Link)`
    text-decoration: none;
  `
  return (
    <StyledLink to={props.href} data-button-secondary-link>
      <ButtonSecondary type="button">
        {props.text}
      </ButtonSecondary>
    </StyledLink>
  )
}

export const ButtonSecondaryWide = styled(ButtonSecondary)`
  width: 270px;
  height: 40px;
  border: 1px solid ${props => props.theme.buttonTextColorSecondary};
  margin-top: 20px;
`
